import { createCollection, localStorageCollectionOptions } from "@tanstack/react-db";
import { z } from "zod";

const InterventionSchema = z.object({
  id: z.number(),
  lastSocratesSessionId: z.string(),
  isFeedbackComplete: z.boolean(),
  lastInteractedOn: z.string(),
});

export const interventionStorageCollection = createCollection(
  localStorageCollectionOptions({
    id: "interventionStorage",
    storageKey: "interventionStorage",
    schema: InterventionSchema,
    getKey: (item) => item.id,
    startSync: true,
    syncMode: "eager",
  }),
);
